import {
  OUTREACH_REPLY_ACCEPT,
  OUTREACH_REPLY_MAX_FILES,
} from '@/lib/outreachReplySend';

function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function OutreachReplyAttachmentPicker({
  files,
  onChange,
  disabled,
}: {
  files: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
}) {
  return (
    <div className='flex flex-col gap-1'>
      <span className='font-semibold text-nova-muted-foreground'>Attachments</span>
      <input
        type='file'
        multiple
        accept={OUTREACH_REPLY_ACCEPT}
        disabled={disabled}
        onChange={(event) => {
          const next = Array.from(event.target.files ?? []);
          const merged = [...files, ...next].slice(0, OUTREACH_REPLY_MAX_FILES);
          onChange(merged);
          event.target.value = '';
        }}
        className='block w-full text-sm text-nova-foreground file:mr-3 file:rounded-md file:border-0 file:bg-nova-muted file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-nova-foreground hover:file:bg-nova-muted disabled:opacity-50'
      />
      <p className='text-xs text-nova-muted-foreground'>
        PDF, image, text, CSV, or Word. Up to {OUTREACH_REPLY_MAX_FILES} files.
      </p>
      {files.length > 0 ? (
        <ul className='mt-1 space-y-1'>
          {files.map((file, index) => (
            <li
              key={`${file.name}-${file.size}-${index}`}
              className='flex items-center justify-between gap-2 rounded-md border border-nova-border bg-nova-muted px-2 py-1 text-sm text-nova-foreground'
            >
              <span className='truncate'>
                {file.name}
                <span className='ml-2 text-xs text-nova-muted-foreground'>
                  {formatSize(file.size)}
                </span>
              </span>
              <button
                type='button'
                disabled={disabled}
                onClick={() => onChange(files.filter((_, i) => i !== index))}
                className='shrink-0 text-xs font-medium text-nova-muted-foreground hover:text-nova-foreground disabled:opacity-50'
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
